<template>
    <v-form ref="etapeValidation" id="etapeValidation" v-model="$storeCandidature.etapeValidationValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <h3 class="text-md-left">
                {{$storeCandidature.langueFormulaire == 'en' ? 'Please check that all the information you have entered is correct' : 'Merci de valider que tous les renseignements que vous avez saisis sont exacts'}}
            </h3>

            <!-- Zone choix du programme -->
            <Comp_Valid_ChoixProgramme etape="1"></Comp_Valid_ChoixProgramme>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone Identification -->
            <Comp_Valid_Identification etape="2"></Comp_Valid_Identification>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone Baccaloréat-->
            <v-form ref="etapeValidationInfoSup" id="etapeValidationInfoSup" v-model="$storeCandidature.ValidationInformationSupplementaireOK" lazy-validation>
                <v-card>
                    <h3 class="text-md-center font-weight-black" style="text-decoration: underline;">
                        {{$storeCandidature.langueFormulaire == 'en' ? 'Step 3 : Educational Background' : 'Etape 3 : Parcours'}}
                    </h3>                   
                    <!-- Début Parcours scolaires -->
                    <h3 class="text-sm-left pl-2">
                        {{$storeCandidature.langueFormulaire == 'en' ? 'My diplomas :' : 'Parcours Scolaire :'}}
                    </h3>
                    <hr size="5" color="secondary" class="mx-2">
                    <v-data-table :headers="headerParcoursScolaires" :items="$storeCandidature.sasCandidature.ListeParcoursScolaire" class="elevation-1 ma-2" disable-pagination hide-default-footer>
                        <template v-slot:no-data>
                            <v-alert :value="true" color="red lighten-1" icon="warning">{{$storeCandidature.langueFormulaire == 'en' ? 'The list is empty (Mandatory)' : 'La liste est vide (Renseignement obligatoire)'}}</v-alert>
                        </template>
                        <template v-slot:item={item}>
                            <!--On n'affiche dans la liste que les parcours hors terminale (Bac) et non supprimé-->
                            <tr v-if="!item.Supprimer && !item.AnneeTerminale">
                                <th class="text-xs-left">{{item.DiplomeObtenu}}</th>
                                <th class="text-xs-left">{{item.AnneeScolairePostBac ? ($storeCandidature.langueFormulaire == 'en' ? item.AnneeScolairePostBac.Lang01 : item.AnneeScolairePostBac.Lang00) : ''}}</th>
                                <th class="text-xs-left">{{item.EtablissementPostBac ? item.EtablissementPostBac.Label : item.EtablissementAutre}}</th>
                                <th class="text-xs-left">{{item.NiveauEtudes ? ($storeCandidature.langueFormulaire == 'en' ? item.NiveauEtudes.Lang01 : item.NiveauEtudes.Lang00) : ''}}</th>
                                <th>
                                    <v-checkbox v-model="item.RedoublementPostBac" disabled hide-details></v-checkbox>
                                </th>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
                <v-layout row wrap xs12 my-2></v-layout>
            </v-form>

            <!-- Zone Pièce à joindre-->
            <Comp_Valid_PiecesJointe etape="4"></Comp_Valid_PiecesJointe>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone Payement-->
            <Comp_Valid_Paiement etape="5"></Comp_Valid_Paiement>

            <!--Consentement-->
            <v-layout row wrap xs12 my-2></v-layout>
            <v-card mt-2 pa-2>
                <h3 class="text-md-center font-weight-black" style="text-decoration: underline;">{{$storeCandidature.langueFormulaire == 'en' ? 'Step 6 : Data entered is correct' : 'Etape 6 : Données exactes'}}</h3>
                <v-switch class="pa-2"
                          :label="$storeCandidature.langueFormulaire == 'en' ? 'I confirm that the information given on this form is true, complete and accurate and no requested or other material information has been omitted. I have read the instructions on completing the application form and give my consent to the processing of my data by the International University of Monaco or the relevant Schools partner of the INSEEC Group. I note that if I do not fully comply with these requirements, the University and Colleges have the right to cancel my application and I will have no claim against the University or Colleges in relation thereto. I am aware that I can have access to my personal information and correct it either through the Registrar of the International University of Monaco or directly through the Intranet system (in accordance with Act n°1.353, dated 2008/12/04 (Monaco CCIN)). '
                          : 'Je certifie que mes données saisies sont exactes. Toute fraude ou tentative de fraude dans les renseignements fournis, lors du dépôt de candidature, peut donner lieu à des sanctions allant jusqu\'a l\'invalidation de l\'inscrption et donc la perte de tout droit ou avantage obtenus'"
                          :readonly="!$storeCandidature.sasCandidature.Statut || $storeCandidature.sasCandidature.Statut.Id != $storeCandidature.configurationClient.StatutCandidatureEnCoursId"
                          v-model="$storeCandidature.sasCandidature.Identification.CertifiDonneeCorrect" :rules="[$rules.accepterCertification($storeCandidature.langueFormulaire)]"></v-switch>
            </v-card>
        </v-container>
    </v-form>
</template>

<script>
    import Comp_Valid_ChoixProgramme from "../components/CompValidationChoixProgramme";
    import Comp_Valid_Identification from "../components/CompValidationIdentification";
    import Comp_Valid_PiecesJointe from "../components/CompValidationPiecesJointes";
    import Comp_Valid_Paiement from "../components/CompValidationPaiement";

    export default {
        components: {
            Comp_Valid_ChoixProgramme,
            Comp_Valid_Identification,
            Comp_Valid_PiecesJointe,
            Comp_Valid_Paiement
        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                testcheck: false,

                // Header parcours scolaires
                headerParcoursScolaires: [
                     { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire', value: 'anneScolaire' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études', value: 'niveauEtudes' },  
                    { text: '', value: 'actions', sortable: false }
                ],
            }
        },

        methods: {
            // Formatage de la date
            formatDate(date) {
                if (date) { return this.$moment(String(date)).format('DD/MM/YYYY') }
                else { return '' }
            },
        }
    }
</script>

<style>
</style>